import { EthAddress } from '@xylabs/sdk-js'
import { TypedEvent, XyoWorldGeotokens } from '@xyo-network/world-typechain'

import { Quadkey } from '../../../Quadkey'
import { MinterDeployBlocks } from '../DeployBlocks'

export class EventsV3 {
  public address?: EthAddress

  public geotokens: XyoWorldGeotokens

  public quadkey?: Quadkey

  constructor(geotokens: XyoWorldGeotokens, filter?: { address?: EthAddress; quadkey?: Quadkey }) {
    this.quadkey = filter?.quadkey
    this.address = filter?.address
    this.geotokens = geotokens
  }

  public async all(fromBlockOrBlockHash?: number | string, toBlock?: number) {
    const promises: Promise<TypedEvent[]>[] = []
    promises.push(this.approval(fromBlockOrBlockHash, toBlock))

    const events = await Promise.all(promises)

    return events.flat().sort((n1, n2) => {
      if (n1.blockNumber < n2.blockNumber) {
        return -1
      }
      if (n1.blockNumber > n2.blockNumber) {
        return 1
      }
      return 0
    })
  }

  public async approval(fromBlockOrBlockHash: number | string = MinterDeployBlocks.v3, toBlock?: number) {
    return await this.geotokens.queryFilter(
      this.geotokens.filters.Approval(this.address?.toString() ?? null, null, this.quadkey?.toBase10String() ?? null),
      fromBlockOrBlockHash,
      toBlock,
    )
  }

  public async approvalForAll(fromBlockOrBlockHash: number | string = MinterDeployBlocks.v3, toBlock?: number) {
    return await this.geotokens.queryFilter(
      this.geotokens.filters.ApprovalForAll(this.address?.toString() ?? null, null, null),
      fromBlockOrBlockHash,
      toBlock,
    )
  }

  public async dataSet(fromBlockOrBlockHash: number | string = MinterDeployBlocks.v3, toBlock?: number) {
    return await this.geotokens.queryFilter(
      this.geotokens.filters['DataSet(address,uint256,uint256,uint256)'](
        this.address?.toString() ?? null,
        this.quadkey?.toBase10String() ?? null,
        null,
        null,
      ),
      fromBlockOrBlockHash,
      toBlock,
    )
  }

  public async erc20Deposited(fromBlockOrBlockHash: number | string = MinterDeployBlocks.v3, toBlock?: number) {
    return await this.geotokens.queryFilter(
      this.geotokens.filters.Erc20Deposited(this.address?.toString() ?? null, this.quadkey?.toBase10String() ?? null, null, null, null),
      fromBlockOrBlockHash,
      toBlock,
    )
  }

  public async erc20Withdrew(fromBlockOrBlockHash: number | string = MinterDeployBlocks.v3, toBlock?: number) {
    return await this.geotokens.queryFilter(
      this.geotokens.filters.Erc20Withdrew(this.address?.toString() ?? null, this.quadkey?.toBase10String() ?? null, null, null, null),
      fromBlockOrBlockHash,
      toBlock,
    )
  }

  public async erc721Deposited(fromBlockOrBlockHash: number | string = MinterDeployBlocks.v3, toBlock?: number) {
    return await this.geotokens.queryFilter(
      this.geotokens.filters.Erc721Deposited(this.address?.toString() ?? null, this.quadkey?.toBase10String() ?? null, null, null),
      fromBlockOrBlockHash,
      toBlock,
    )
  }

  public async erc721Withdrew(fromBlockOrBlockHash: number | string = MinterDeployBlocks.v3, toBlock?: number) {
    return await this.geotokens.queryFilter(
      this.geotokens.filters.Erc721Withdrew(this.address?.toString() ?? null, this.quadkey?.toBase10String() ?? null, null, null),
      fromBlockOrBlockHash,
      toBlock,
    )
  }

  public async minted(fromBlockOrBlockHash: number | string = MinterDeployBlocks.v3, toBlock?: number) {
    return await this.geotokens.queryFilter(
      this.geotokens.filters.Minted(this.address?.toString() ?? null, this.quadkey?.toBase10String() ?? null),
      fromBlockOrBlockHash,
      toBlock,
    )
  }

  public async minterSet(fromBlockOrBlockHash: number | string = MinterDeployBlocks.v3, toBlock?: number) {
    return await this.geotokens.queryFilter(this.geotokens.filters.MinterSet(null), fromBlockOrBlockHash, toBlock)
  }

  public async safeMinted(fromBlockOrBlockHash: number | string = MinterDeployBlocks.v3, toBlock?: number) {
    return await this.geotokens.queryFilter(
      this.geotokens.filters.SafeMinted(this.address?.toString() ?? null, this.quadkey?.toBase10String() ?? null),
      fromBlockOrBlockHash,
      toBlock,
    )
  }

  public async transfer(fromBlockOrBlockHash: number | string = MinterDeployBlocks.v3, toBlock?: number) {
    return await this.geotokens.queryFilter(
      this.geotokens.filters.Transfer(this.address?.toString() ?? null, null, this.quadkey?.toBase10String() ?? null),
      fromBlockOrBlockHash,
      toBlock,
    )
  }
}
